// Module
var code = " <gh-grid-cell-editor-container [control]=\"control\"> <div class=\"input-wrapper\"> <input #input=\"\" class=\"cell-input\" [required]=\"required\" [formControl]=\"control\" [ghMaskedType]=\"type\" (blur)=\"onBlur()\" type=\"text\"> </div> </gh-grid-cell-editor-container>";
// Exports
module.exports = code;